import { type MetaDescriptor } from '@remix-run/node'

/** Normaliza texto para meta description (evita espaços excessivos; limita tamanho). */
export function truncateMetaDescription(text: string, maxLen = 160): string {
  const single = text.replace(/\s+/g, ' ').trim()
  if (single.length <= maxLen) return single
  const cut = single.slice(0, maxLen - 1).trimEnd()
  return `${cut}…`
}

export function metaTitleAndDescription({
  title,
  description,
  content_type,
  image,
  canonicalUrl,
}: {
  title: string
  description: string
  content_type: string
  image?: string
  /** URL absoluta da página (canonical + og:url). */
  canonicalUrl?: string
}): MetaDescriptor[] {
  const twitterCard = image ? 'summary_large_image' : 'summary'
  const tags: MetaDescriptor[] = [
    { title },
    { name: 'description', content: description },
    { property: 'og:title', content: title },
    { property: 'og:description', content: description },
    { property: 'og:type', content: content_type },
    { property: 'og:site_name', content: 'Clube do Tennis' },
    { name: 'twitter:card', content: twitterCard },
    { name: 'twitter:title', content: title },
    { name: 'twitter:description', content: description },
  ]

  if (canonicalUrl) {
    tags.push({ property: 'og:url', content: canonicalUrl })
    tags.push({
      tagName: 'link',
      rel: 'canonical',
      href: canonicalUrl,
    })
  }

  if (image) {
    tags.push({ property: 'og:image', content: image })
    tags.push({ name: 'twitter:image', content: image })
  }

  return tags
}
